// These buttons read as a column along the right edge, so they share a minimum
// width. A longer label in another language simply overflows — a slightly wide
// button beats a truncated label.
import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button, { buttonVariants } from "@react/shared/ui/Button"

// The width of the widest French label ("Bon de commande", 157 px), rounded.
export const ACTION_WIDTH = "min-w-[160px]"

const ActionButton = ({ icon = "plus", className = "", href, children, ...props }) => {
  const shape = `shrink-0 ${ACTION_WIDTH} ${className}`.trim()

  if (href) {
    return (
      <a href={href} className={`${buttonVariants({ variant: "primary", size: "sm" })} ${shape}`}>
        {icon && <FontAwesomeIcon icon={icon} className="text-[12px]" />}
        {children}
      </a>
    )
  }

  return (
    <Button variant="primary" size="sm" className={shape} {...props}>
      {icon && <FontAwesomeIcon icon={icon} className="text-[12px]" />}
      {children}
    </Button>
  )
}

export default ActionButton
